export default "__VITE_ASSET__CMBE$UVP__"